<template>
	<Modal v-bind="$attrs" v-on="$listeners" :xIconDisabled="true">
		<div class="flex">		
				<div class="text-xs text-gray-700">＊スマホでは画面を横にするとトリミング操作がしやすくなります＊</div>
				<SecondaryButton
					text="閉じる"
					class="ml-auto w-fit block my-1 mr-1 px-5"
					@click="closed()"
				>
			</SecondaryButton>
		</div>

		<div v-if="loading" class="font-bold text-gray-700 text-center animate-pulse my-10">
			準備中...
		</div>
		
		<div v-if="imgSrc" class="rounded overflow-auto w-fit main">
			<div class="w-full h-full p-5">
				<!-- 画像トリミング領域 -->
				<vue-cropper
					ref="cropper"
					:img="imgSrc"
					:output-size="1"
					:auto-crop="true"
					:auto-crop-width="734"
					:auto-crop-height="440"
					:zoom="zoom"
					:fixed-box="false"  
					:can-move="true"
					:can-move-box="true"
					:center-box="false"
					:output-type="'png'"
				></vue-cropper>


				<div class="flex m-1 mt-10">
					<PrimaryButton text="↺ 左回転" class="w-full bg-blue-200 text-blue-700 font-bold mx-1 mb-1" @click="rotateLeft" ></PrimaryButton>
					<PrimaryButton text="↻ 右回転" class="w-full bg-blue-200 text-blue-700 font-bold mx-1 mb-1" @click="rotateRight" ></PrimaryButton>
				</div>

				<div class=" m-1 mt-16">
					<PrimaryButton text="加工完了" class="w-full" @click="save()" ></PrimaryButton>
				</div>
				
			</div>
		</div>
	</Modal>
</template>

<script>
import Modal from '@components/Modal.vue'
import PrimaryButton from '@components/PrimaryButton.vue'
import SecondaryButton from '@components/SecondaryButton.vue'
import { VueCropper }  from 'vue-cropper'
import * as backend from '@libs/backend'
import * as image from '@libs/image'

export default {
	components: {
		Modal,
		PrimaryButton,
		SecondaryButton,
		VueCropper
	},

	props: ['open', 'target'],

	data() {
		return {
			loading: false,

			imgSrc: null,
			// ズームの初期値
			zoom: 1,
		}
	},

	computed: {
	},

	watch: {
		open() {
			if (this.open) {
				this.getTarget()
			}
		}
	},

	methods: {
		/**
		 * データ取得
		 */
		async getTarget() {
			this.loading = true

			// BASE64を取得する
			const blob = await backend.searchData('photoReport/getS3Blob', { photoPath: this.target.photoPath })
			this.imgSrc = image.bufferToDataUrl(blob.data.data)

			this.loading = false
		},

		/**
		 * 左に90度回転
		 */
		rotateLeft() {
			this.$refs.cropper.rotateLeft()
		},

		/**
		 * 右に90度回転
		 */
		rotateRight() {
			this.$refs.cropper.rotateRight()
		},

		/**
		 * 完了
		 */
		save() {
			// Base64で取得
			this.$refs.cropper.getCropData(data => {
				this.$emit('saveRetouch', { data, target: this.target })
				this.closed()
			})
		},

		/**
		 * モーダルclose
		 */
		closed() {
			this.imgSrc = null
			// ズームの初期値
			this.zoom = 1
			this.$emit('closed')
		},
	}
}
</script>
<style scoped>
.vue-cropper >>> .cropper-view-box::before {
	background-color: transparent !important;
}

.vue-cropper >>> .cropper-view-box {
	outline: 2px dashed blue !important;
	outline-color: blue !important;
}

.vue-cropper >>> .crop-point {
	background-color: rgb(17, 245, 207) !important;
	width: 30px;   /* 20px → 30px に拡大 */
	height: 30px;
	margin: -15px; /* 中心合わせ */
}

.vue-cropper {
	width: 734px !important;
	height: 440px !important;
	padding: 10px !important;
	touch-action: none !important;
}

</style>